<template>
  <div class="reading-content">
      <div class="reading-title">欢迎</div>
      <div class="reading-main" v-html='reading'>
         
     </div>
    </div>  
</template>

<script>


export default {
  name: 'hello',
  props:['showflag'],
  data () {
    return {
      reading:""
    }
  },
  computed: {
   
  },
  methods: {
     
     async query() {
        let me=this;
         let param={
            welcomeStr:""
          };
          let res = await this.$userService.saveOrGetWelcome(param);
          if(res.success){
            me.reading=res.content;
          }
      }
  },
  created: async function () {
    this.$global.activeMenu = ""; //不激活左侧
    this.query();
  },
  mounted () {
    this.query();
    
  },
  watch:{
   
  },
}
</script>
<style lang="scss" scoped>
  .reading-content{
    padding:30px;
    .reading-title{
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      color: #535B6C;
    }
    .reading-main{
      font-size: 16px;
      padding:20px;
      border: 1px solid #D0D4DC;
      color: #545B6D;margin: 20px 0;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue